import { Address } from "@/types/Address";

export function openInGoogleMaps(address: Address) {
  const { address1, address2, city, state, zip } = address;
  const query = `${address1} ${address2 ? address2 + " " : ""}${city}, ${state} ${zip}`;
  const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  window.open(url, "_blank");
}
